import { render, staticRenderFns } from "./CreateAgentScreen.vue?vue&type=template&id=422731a2"
import script from "./CreateAgentScreen.vue?vue&type=script&lang=ts"
export * from "./CreateAgentScreen.vue?vue&type=script&lang=ts"
import style0 from "./CreateAgentScreen.vue?vue&type=style&index=0&id=422731a2&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QForm,QInput,QSelect,QSkeleton});
